import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100 mt-16">
      <div className="w-full max-w-page mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">漂亮的姐姐</span>
            </div>
            <p className="mt-4 text-sm text-primary-100 leading-relaxed max-w-md">
              漂亮的姐姐是一个聚合影视剧信息与行业动态的综合平台，提供最新热门电视剧推荐、剧情介绍与演员动态，
              帮助你轻松了解和追踪喜欢的影视内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="mailto:hello@pljj-film.example" aria-label="发送邮件" className="w-9 h-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
              <a href="https://2p0i.cn" target="_blank" rel="nofollow noopener noreferrer" aria-label="微博" className="w-9 h-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="哔哩哔哩" className="w-9 h-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-fill"></i>
              </a>
              <a href="https://www.douban.com" target="_blank" rel="nofollow noopener noreferrer" aria-label="豆瓣" className="w-9 h-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-douban-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">内容导航</h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><Link to="/category/tv-series" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">电视剧分类</Link></li>
              <li><Link to="/category/news" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">影视资讯</Link></li>
              <li><Link to="/category/actors" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">演员动态</Link></li>
              <li><Link to="/search" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">关于我们</h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">网站介绍</Link></li>
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">团队与联系</Link></li>
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">使用条款</Link></li>
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors cursor-pointer">隐私政策</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200">
          <p>© 2026 漂亮的姐姐 · 影视资讯门户 · 本站内容为演示数据，仅供学习与浏览参考</p>
          <p className="flex items-center gap-2">
            <i className="ri-mail-send-line"></i>
            hello@pljj-film.example
          </p>
        </div>
      </div>
    </footer>
  );
}